module.exports = __webpack_public_path__ + "static/media/accessdeniedlogo.6604a041.svg";